import { type FC } from "react";

import { buildDynamicTermLink } from "../../../entities/cards/AttributeValuesCardRows.js";
import { type IAgGridCellProps } from "../cell-base-interfaces.js";
import { traverseAndCollect } from "../column-props-factory.js";
import ListCellContent, { type ListCellItem } from "./core/ListCellContent.js";
import { TableCell } from "./core/TableCell.js";
import TableCellText from "./core/TableCellText.js";
import { type DynamicVocabularyTerm } from "@/graphql.ts";
import { nonBreakingSpace } from "@/settings/settings.js";

const DynamicTermCell: FC<IAgGridCellProps> = (props) => {
  if (props.data == null) {
    return null;
  }
  const { data, colDef, context } = props;
  if (props.context?.editMode) {
    return <TableCellText {...props} />;
  }

  const value = traverseAndCollect(data, colDef.groupField || colDef.field);
  const multiValues: DynamicVocabularyTerm[] = Array.isArray(value) ? value : [value];

  const items: ListCellItem[] = multiValues.map((dynTermAttribute: DynamicVocabularyTerm) => {
    const listCellItem: ListCellItem = {
      value: dynTermAttribute ? buildDynamicTermLink(dynTermAttribute) : nonBreakingSpace,
      tooltip: dynTermAttribute?.name ?? nonBreakingSpace,
    };
    return listCellItem;
  });

  return (
    <TableCell>
      <ListCellContent items={items} colDef={props.colDef} context={context} />
    </TableCell>
  );
};

export default DynamicTermCell;
